
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const Transformation = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="Transformation" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M4.8515 4.14l-3.5-3.5-.707.707 3.5 3.5-2.146 2.147h5v-5zm1.147 1.854h-1.586l1.586-1.586zm9.344 8.66l-3.5-3.5 2.156-2.16h-5v5l2.134-2.134 3.5 3.5zm-5.344-4.66h1.586l-1.586 1.585zm5.369-8.636l-.707-.707-3.5 3.5-2.162-2.157v5h5l-2.134-2.134zm-5.369 4.636V4.408l1.586 1.586zm-3 3h-5l2.134 2.134-3.5 3.5.707.707 3.5-3.5 2.159 2.159zm-1 2.586l-1.585-1.586h1.585z" />
</svg>
    </HvIconBase>
)};

Transformation.propTypes = HvIconBase.propTypes;

export default Transformation;